import { Navigate } from "react-router-dom";
import { clearPartnerStorage, getLanguageCookie, getStorageValue,get_clck } from "./shared.service";
// import toastr from "../components/elements/toast";
// const flags = {
//   SESSION_EXPIRED: 4,
// };
const baseUrl = process.env.REACT_APP_API_URL || "https://devapi.credee.com/partner/";
// const baseUrl = "http://localhost:8001/partner/";
console.log(process.env);
const defaultBodyParams: any = {
  app_version: 130,
  app_type: 10,
  device_token: "Website",
  device_type: 0,
  environment: process.env.REACT_APP_SERVER
};
const apsRequireDefaultParams = ['email_login', 'get_settings', 'access_token_login', 'register_partner',"change_password",'get_profile', 'change_password_reset']
export default async function httpApiCall(params: any) {
  params.body = params.body ? params.body : {};
  const partner_storage = getStorageValue("user");
  defaultBodyParams["device_id"] = partner_storage;

  const langPref = await getLanguageCookie();
  params.body["language_preffered"] = params.body.language_preffered || langPref || "en";
  
  const getClck = await get_clck();
  if (apsRequireDefaultParams.indexOf(params.api) >= 0) {
    params.body = { ...params.body, ...defaultBodyParams };
  }
  var headers: any = {
    Accept: "*/*",
    // "Content-Type": params.content_type || "application/json",
    "x-client-url": window.location.href,
    "x-lan-code": "en",
  };
  if(getClck) {
    headers['x-clck-id'] = getClck[1];
  }
  if (params.type == 'form') {
    const formdata = new FormData();
    const keys = Object.keys(params.body);
    keys.map(item => {
      formdata.append(item, params.body[item]);
      return item;
    })
    params.body = formdata;
    params.type = 'post';
  } 
  else {
    // let body = new URLSearchParams();
    // const keys = Object.keys(params.body);
    // keys.map(item => {
    //   body.set(item, params.body[item]);
    //   return item;      
    // })
    //   params.body = body;

    headers['Content-Type'] = 'application/json';
    params.body = JSON.stringify(params.body);
  }
  let url = baseUrl + params.api;
  // if (params.api.includes('book_partner_training')) {
  //   url = 'http://localhost:8001/' + params.api;
  // }
  const response = await fetch(url, {
    method: params.type || "GET",
    headers: headers,
    body: params.body,
  }).then((response) => {
      return response.json();
    }).catch((err) => {
      console.log(err);
    }
  );
  if (response && response.is_error == 1 && response.flag == 4) {
    clearPartnerStorage();
    setTimeout(() => {
      <Navigate to="/login" replace={true} />;
    }, 200);
  }
  return response;
}
